import React, { useState } from 'react'
import ContributionRow from './ContributionRow'

export default function ContributionLines(props) {

  const [lineTotal, setLineTotal] = useState(() => { return props.lines.reduce((total, p) => total + (p.amount || 0), 0) } )
  let existinglines = props.lines.slice() // clone the existing lines
  let numberOfBlanklines = 1

  let newId = existinglines.reduce((min, p) => (p.contributionLineId < min) ? p.contributionLineId : min, 0)
  //consoleconsole.log(`newId ${newId}`)

  function handleRowUpdate(rowData) {
    let newtotal = props.rowUpdate(rowData)
    setLineTotal(newtotal)
    //console.log(lineTotal )
  }

  //let initialTotal = props.lines.reduce((total, p) => total + (p.amount || 0), 0)
//  console.log("initalTotal " + lineTotal)
//  if (newId === 0) {
    for (var i = 0; i < numberOfBlanklines; i++) {
      newId = newId - 1
      existinglines.push({
        "fund": "",
        "amount": "",
        "contributionLineId": newId,
        "contributionId": props.contributionId
      })
    }
//  }

  //let totalAmount = 0
  //let editlines = this.props.lines.concat(blanklines)
  let lines = existinglines
    .map((ln, index) => {
      let key = props.contributionId.toString() + ln.contributionLineId.toString() //+ ln.fund
      //totalAmount += ln.amount
      return <ContributionRow rowUpdate={handleRowUpdate}
        key={key} line={ln} funds={props.funds}
      />

    })

  let footer = (
    <tr className="footer">
    <td>Total</td>
      <td>{parseFloat(lineTotal).toFixed(2)}&nbsp;</td>
    </tr>)

  //console.log("render ContributionLines")
  return <div className="ant-table ant-table-middle" >
    <div className="ant-table-content">
      <div className="ant-table-body ">
        <table className="" >
          <thead className="ant-table-thead">
            <tr>
              <th>
                <div>Fund</div>
              </th>
              <th>
                <div>Amount</div>
              </th>
            </tr>
          </thead>
          <tbody className="ant-table-tbody">
            {lines}{footer}
          </tbody>
        </table>
      </div></div>
  </div>
}


//export default ContributionLines